// Symmetry (Venus): a word that begins and ends with the same letter scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { lettersOf } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const symmetry: AlignmentDef = {
  id: 'symmetry',
  planet: 'venus',
  name: 'Symmetry',
  text: () => `Words that begin and end with the same letter score +${N.symmetryPercent}%.`,
  wordPercent: (c) => {
    const letters = lettersOf(c.word);
    return letters.length >= 2 && letters[0] === letters[letters.length - 1] ? N.symmetryPercent : 0;
  },
};
